/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Signers_PlaceholderInputs */

const cs_tasks_protocol_signers_placeholder = /** @type {(inputs: Tasks_Protocol_Signers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`klient@firma.cz nebo klient@firma.cz,+420777123456 — jeden na řádek`)
};

const en_tasks_protocol_signers_placeholder = /** @type {(inputs: Tasks_Protocol_Signers_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`client@example.com or client@example.com,+420777123456 — one per line`)
};

/**
* | output |
* | --- |
* | "client@example.com or client@example.com,+420777123456 — one per line" |
*
* @param {Tasks_Protocol_Signers_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_signers_placeholder = /** @type {((inputs?: Tasks_Protocol_Signers_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Signers_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_signers_placeholder(inputs)
	return cs_tasks_protocol_signers_placeholder(inputs)
});